import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronLeftSm = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13.5 16L9.5 12L13.5 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronLeftSm.js.map